import { Injectable } from '@angular/core';
import { HelperService } from './helper.service';
import { ReplaceEmojisPipe } from '../pipes/replace-emoji/replace-emojis.pipe';

@Injectable({ providedIn: 'root' })
export class ReplyTemplateManagerService {
    constructor(private replaceEmojisPipe: ReplaceEmojisPipe) {}

    chooseReplyTemplate({
        $event,
        templateText,
        quillEditor,
        quillRange,
        isSmile,
        isSetCaretAtStart,
        isFocusNotNeeded,
        reply,
        attachments,
    }: {
        $event: any;
        templateText: any;
        quillEditor: any;
        quillRange: any;
        isSmile?: boolean;
        isSetCaretAtStart?: boolean;
        isFocusNotNeeded?: boolean;
        reply?: any;
        attachments?: any;
    }) {
        let editorBlock;

        if (isSmile) {
            templateText = this.replaceEmojisPipe.transform(templateText.native)[
                'changingThisBreaksApplicationSecurity'
            ];
        }

        let textarea;

        if (isSmile) {
            editorBlock = $($event.target).closest('.smile-field-container').find('.smile-field');
            textarea = editorBlock;
        } else {
            editorBlock = $($event.target).closest('.ticket-message');
            textarea = editorBlock.find('.ql-editor');
        }

        // quillEditor.focus();

        if (!quillRange) {
            if (!isFocusNotNeeded) {
                quillEditor.focus();
            }
            quillRange = this.updateRange(quillEditor);
        }

        if (isSmile) {
            quillEditor.insertEmbed(quillRange.index, 'emoji', templateText, 'user');
        } else {
            if (isFocusNotNeeded) {
                quillEditor.clipboard.dangerouslyPasteHTML(quillRange.index, templateText, 'api');
            } else {
                quillEditor.clipboard.dangerouslyPasteHTML(quillRange.index, templateText, 'user');
            }
        }

        if (reply && attachments?.length) {
            if (!reply.attachments) {
                reply.attachments = [];
            }
            reply.attachments = [...reply.attachments, ...attachments];
        }

        setTimeout(() => {
            if (isSmile) {
                quillEditor.setSelection(quillRange.index + 1);
            }

            if (!isFocusNotNeeded) {
                if (isSetCaretAtStart) {
                    HelperService.placeCaretAtStart(textarea);
                } else {
                    quillEditor.focus();
                }
            }
        }, 100);

        return;
    }

    updateRange(quill) {
        let range = quill.getSelection();
        const length = quill.getLength();
        if (range == null) {
            range = { index: length, length };
        }
        return range;
    }
}
